export interface IScaleData {
    topValue: number | null;
    midValue: number | null;
    botValue: number | null;
    rate: string | null;
    topEqBottom: boolean | null;
}


export function initRatingsScale(): void {


    const state: IScaleData = {
        topValue: 50,
        midValue: 100,
        botValue: 50,
        rate: "Delivering",
        topEqBottom: null,
    };

    const topSlider = document.getElementById("topSlider") as HTMLInputElement | null;
    const bottomSlider = document.getElementById("bottomSlider") as HTMLInputElement | null;
    const middleSlider = document.getElementById("middleSlider") as HTMLInputElement | null;


    if (!topSlider || !bottomSlider || !middleSlider) {
        return;
    }

        topSlider.disabled = true;
        bottomSlider.disabled = true;
        middleSlider.disabled = true;

        topSlider.addEventListener("change", () => {
            state.topValue = parseInt(topSlider.value, 10);
            updateTopSlider(state);
        });

        bottomSlider.addEventListener("change", () => {
            state.botValue = parseInt(bottomSlider.value, 10);
            updateTopSlider(state);
        });

        middleSlider.addEventListener("input", () => {
            state.midValue = parseInt(middleSlider.value, 10);
        });

        updateTopSlider(state);
}


function updateTopSlider(state: IScaleData): void {
    const topSlider = document.getElementById("topSlider") as HTMLInputElement | null;
    const bottomSlider = document.getElementById("bottomSlider") as HTMLInputElement | null;
    const rangeBullet = document.getElementById("rs-bullet") as HTMLElement | null;
    const lineBoxLower = document.getElementById("line-container-lower") as HTMLElement | null;
    const lineBoxUpper = document.getElementById("line-container-upper") as HTMLElement | null;

    if (!topSlider || !bottomSlider || !rangeBullet || !lineBoxUpper || !lineBoxLower || !rangeBullet) {
        return;
    }
        topSlider.disabled = true;
        bottomSlider.disabled = true;

        rangeBullet.style.transform = "scaleY(0)";
        lineBoxUpper.style.opacity = "0";
        lineBoxLower.style.opacity = "0";
        rangeBullet.style.opacity = "0";

    

    let lowerBoxPos = Math.floor(state.botValue!);
    let upperBoxPos = Math.floor(state.topValue!);

    let oPointUpper = "top right";
    let oPointLower = "bottom right";

    const upper = state.topValue!;
    const lower = state.botValue!;
    const mid = Math.floor(upper + lower);

    let widthLower = 0;
    let widthUpper = 0;

    if (lower < upper) {
        const rangeLower = upper - 8;
        state.topEqBottom = lower > rangeLower;

        upperBoxPos = Math.floor(mid / 2);
        widthUpper = Math.ceil(upper - mid / 2);
        widthLower = Math.floor(mid / 2 - lowerBoxPos);

        oPointLower = "bottom left";
        oPointUpper = "top right";

        lineBoxLower.style.borderLeftStyle = "solid";
        lineBoxLower.style.borderRightStyle = "hidden";
        lineBoxUpper.style.borderLeftStyle = "hidden";
        lineBoxUpper.style.borderRightStyle = "solid";
    } else if (lower === upper) {
        state.topEqBottom = true;
    } else {
        const rangeUpper = upper + 8;
        state.topEqBottom = lower < rangeUpper;

        oPointUpper = "top left";
        oPointLower = "bottom right";

        lowerBoxPos = Math.floor(mid / 2);
        widthUpper = Math.floor(mid / 2 - upperBoxPos);
        widthLower = Math.ceil(lower - mid / 2);

        lineBoxLower.style.borderRightStyle = "solid";
        lineBoxLower.style.borderLeftStyle = "hidden";
        lineBoxUpper.style.borderRightStyle = "hidden";
        lineBoxUpper.style.borderLeftStyle = "solid";
    }

    lineBoxLower.style.width = `${widthLower}%`;
    lineBoxUpper.style.width = `${widthUpper}%`;
    lineBoxLower.style.left = `${lowerBoxPos}%`;
    lineBoxUpper.style.left = `${upperBoxPos}%`;

    const bulletPosition = mid;

    setTimeout(() => {
        lineBoxUpper.style.transform = "scaleY(0)";
        lineBoxLower.style.transform = "scaleY(0)";
        lineBoxUpper.style.transform = "scaleX(0.3)";
        lineBoxLower.style.transform = "scaleX(0.3)";
        lineBoxUpper.style.transformOrigin = oPointUpper;
        lineBoxLower.style.transformOrigin = oPointLower;
    }, 500);

    setTimeout(() => {
        lineBoxUpper.style.opacity = "1";
        lineBoxLower.style.opacity = "1";
        rangeBullet.style.left = `${bulletPosition / 2}%`;
        lineBoxUpper.style.transform = "scaleY(1)";
        lineBoxLower.style.transform = "scaleY(1)";
    }, 1000);

    setTimeout(() => {
        lineBoxUpper.style.transform = "scaleX(1)";
        lineBoxLower.style.transform = "scaleX(1)";
    }, 1300);

    animateSlider(mid, state.midValue!, rangeBullet, state);
}


const animateSlider = (start: number,end: number, element: HTMLElement,state: IScaleData): void => {

    const rangeBullet = document.getElementById("rs-bullet") as HTMLElement | null;
    const topSlider = document.getElementById("topSlider") as HTMLInputElement | null;
    const bottomSlider = document.getElementById("bottomSlider") as HTMLInputElement | null;
    const middleSlider = document.getElementById("middleSlider") as HTMLInputElement | null;

    if (!rangeBullet || !topSlider || !bottomSlider || !middleSlider) {
        return;
    }
   
    middleSlider.value = state.midValue!.toString();
    

    if (start === end) {
        setTimeout(() => {
            if (!state.topEqBottom) {
                rangeBullet.style.opacity = "1";
                rangeBullet.style.transform = "scaleY(1)";
            }
            topSlider.disabled = false;
            bottomSlider.disabled = false;
        }, 700);
    } else {
        setTimeout(() => {
            if (start > end) {
                state.midValue!++;
                animateSlider(start, state.midValue!, element, state);
            } else if (start < end) {
                state.midValue!--;
                animateSlider(start, state.midValue!, element, state);
            }
        }, 10);
    }
}

